<template>
  <el-tooltip content="请务必从建议列表中选择公司" placement="top" effect="dark">
    <el-autocomplete
      ref="innerInput"
      v-model="selection"
      suffix-icon="el-icon-search"
      popper-class="autocomplete-popper"
      @blur="handleCompanyBlur"
      @select="handleSelectCompany"
      @input="handleChange"
      :disabled="disabled"
      :trigger-on-focus="triggerOnFocus"
      :fetch-suggestions="searchCompany"
      :placeholder="placeholder"
    ></el-autocomplete>
  </el-tooltip>
</template>

<script>
import companyService from '@/api/company.js'

export default {
  name: 'SearchCompany',
  props: {
    value: {
      type: String,
      default: ''
    },
    defaultOptions: {
      type: Array,
      default() {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '输入公司ID或公司名搜索'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    triggerOnFocus: {
      type: Boolean,
      default: false
    },
    addEmpty: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hadCompanySelect: false,
      suggestList: [],
      selection: '',
    }
  },
  watch: {
    value(newVal) {
      this.selection = newVal
    },
    selection(newVal) {
      this.$emit('update:value', newVal)
    }
  },
  created() {
    this.selection = this.value
    this.suggestList = this.defaultOptions
  },
  methods: {
    focus() {
      this.$refs.innerInput.focus()
    },
    /**
     * 公司失去焦点回调
     * 1. 如果此时没有选中一个结果并且结果集不为空, 默认选择第一个结果
     * 2. 结果集为空并且输入框不为空, 重置输入框
     */
    handleCompanyBlur() {
      if (!this.hadCompanySelect && this.suggestList.length) {
        this.selection = this.suggestList[0].value
        this.hadCompanySelect = true
      } else if (this.selection && !this.selection.includes(' -@- ')) {
        this.selection = ''
      }
    },

    handleChange(val) {
      this.$emit('change', val)
    },

    /**
     * 选择了公司后清空列表
     */
    handleSelectCompany(selected) {
      this.suggestList = []
    },

    searchCompany(queryStr, cb) {
      companyService.searchTme({ keyWord: queryStr }).then(resp => {
        const suggestList = resp.list.map(item => {
          return {
            value: `${item.companyId} -@- ${item.companyName}`
          }
        })
        this.suggestList = suggestList
        this.hadCompanySelect = false

        if (this.addEmpty) {
          suggestList.unshift({ value: '0 -@- 空' })
        }

        cb(suggestList)
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '查找公司异常: ' + error.msg || error,
          type: 'error',
          duration: 5000
        })
        cb([])
      })
    },
  }
}
</script>
